export const questions = [
  {
    id: 1,
    question: "How do you rate your team in HTML, CSS and JS for frontend designing?",
    options: [
      { value: 1, text: "basic" },
      { value: 2, text: "intermediate" },
      { value: 3, text: "advanced" },
      { value: 0, text: "unfamiliar" },
    ],
  },
  {
    id: 2,
    question:
      "What is the familiarity of your team with CSS Frameworks (Bootstrap,Chakra, Material-UI,Nativebase)?",
    options: [
      { value: 1, text: "basic" },
      { value: 2, text: "intermediate" },
      { value: 3, text: "advanced" },
      { value: 0, text: "unfamiliar" },
    ],
  },
  {
    id: 3,
    question:
      "Do you have a dedicated UI/UX team with good knowledge of designing tools like figma, adobe, etc?",
    options: [
      { value: 3, text: "yes" },
      { value: 0, text: "no" },
    ],
  },
];
